import { func, number } from 'prop-types';
import React from 'react';
import { trackEvent } from 'dibs-tracking';
import CartIcon from 'dibs-vg/dist/react/cart-open';

import styles from './CartNav-style.scss';

const MAX_CART_COUNT_DISPLAY = 9;

function handleOnClick() {
    trackEvent({
        category: 'navigation',
        action: 'header navigation click',
        label: 'cart|cart header link',
    });
}

const CartNavCount = ({ count }) => (
    <div className={styles.countWrapper}>
        <span className={styles.count}>
            {count}
            {count === MAX_CART_COUNT_DISPLAY ? <sup>+</sup> : null}
        </span>
    </div>
);

CartNavCount.propTypes = {
    count: number,
};

const CartNavDropdownTrigger = ({ count = 0, handleMouseEnter }) => {
    count = Math.min(count, MAX_CART_COUNT_DISPLAY);

    return (
        <div
            data-tn="cart-nav-dropdown-trigger"
            className={styles.iconWrapper}
            onMouseEnter={handleMouseEnter}
        >
            <a className={styles.icon} href="/my/cart/" onClick={handleOnClick}>
                {count ? <CartNavCount count={count} /> : null}
                <CartIcon />
            </a>
        </div>
    );
};

CartNavDropdownTrigger.defaultProps = {
    handleMouseEnter: () => {},
};

CartNavDropdownTrigger.propTypes = {
    count: number,
    handleMouseEnter: func,
};

export default CartNavDropdownTrigger;
